<template>
  <QCard flat bordered>
    <QExpansionItem
      :header-style="headerStyle"
      :icon="icon"
      :header-class="headerClass"
      outlined
      :label="label"
      v-model="isOpen"
      :disabled="disabled"
    >
      <div :class="innerClass">
        <slot></slot>
      </div>
    </QExpansionItem>
  </QCard>
</template>

<script>
import { QCard, QExpansionItem } from 'quasar';
export default {
  name: 'CustomExpansionItem',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    innerClass: {
      type: String,
      default: 'q-pa-sm'
    },
    headerClass: {
      type: String,
      default: ''
    },
    icon: {},
    headerStyle: {}
  },
  data() {
    return {
      isOpen: this.value
    };
  },
  watch: {
    value(newValue) {
      this.isOpen = newValue;
    },
    isOpen(newIsOpen) {
      this.$emit('input', newIsOpen);
    }
  },
  components: {
    QExpansionItem,
    QCard
  }
};
</script>

<style lang="sass" scoped></style>
